<script setup>

import BaseSettingsForm from "@/Components/UI/forms/BaseSettingsForm.vue";

defineProps({
    form: {
        type: Object,
        required: true,
    },
    title: {
        type: String,
        default: ""
    },
    isArchive: Boolean,
    readOnly: Boolean,
    noTitle: Boolean
});
defineEmits(['submit'])
</script>

<template>
    <BaseSettingsForm :active="!form.processing"
                      :errors="form.errors"
                      :submit-text="isArchive ? 'Восстановить' : 'Сохранить'"
                      :read-only="readOnly"
                      :no-title="noTitle"
                      @submit="$emit('submit')">
        <template #title>
            {{ title }}
        </template>
        <template #content>
            <slot/>
        </template>
    </BaseSettingsForm>
</template>
